module.exports = __webpack_public_path__ + "img/rubric-gray.svg";